import React, {useEffect} from "react";
import {useModel, useModelDispatchers} from "../../../models";
import {Button, Drawer, Form, Input, Select, TreeSelect} from "antd";
import CustomerService from "../../base/customer/CustomerService";
import {goPage} from "../../layout/pageDefinition";
import {useHistory} from "react-router";

const TransferForm = () => {
    const history = useHistory();
    const [form] = Form.useForm();
    const [{customerDict, customerTypeDict, saleOrderTypeDict, invoiceTypeDict, salePriceTypeDict}] = useModel("cmDict");
    const [{selectedDocument,}, {setSelectedDocument, setTransferDrawerVisible, transfer}] = useModel("purchasePo");
    const {loadSo} = useModelDispatchers("saleSo");
    useEffect(() => {
        const {purchaseCode} = selectedDocument;
        form.setFieldsValue({purchaseCode, orderType: "015002"});

    }, []);
    const layout = {
        labelCol: {
            span: 6,
        },
        wrapperCol: {
            span: 18,
        },
    };
    const tailLayout = {
        wrapperCol: {
            offset: 6,
            span: 18,
        },
    };
    const onCustomerChange = async el => {
        let customer = await CustomerService.findOne(el["customerId"]);
        if (customer) {
            const {customerCorporation, customerType, customerCorporationPhone, customerAddress} = customer;
            form.setFieldsValue({
                customerPerson: customerCorporation,
                customerType,
                customerPhone: customerCorporationPhone,
                detailedAddress: customerAddress
            });
        }
    }

    const onFinish = () => {
        const {id} = selectedDocument;
        form.validateFields().then(data => {
            transfer({
                showMsg: true,

                data: {...data, purchaseId: id,}
            }).then(ret => {
                if (ret) {
                    /*setSelectedDocument({
                        ...selectedDocument,
                        /!*paidAmount: selectedDocument.payableAmount,
                        paymentMethod: form.getFieldValue("payType")*!/
                    });*/
                    setTransferDrawerVisible(false);
                    loadSo({showMsg: false, data: ret}).then(() => {
                        goPage(history, "3-2-1");
                    });
                }
            });
        })
    }

    const onClose = () => {
        setTransferDrawerVisible(false)
    }
    return (
        <Form
            {...layout}
            form={form}
            name="po_transfer_form"
            onFinish={onFinish}
            onValuesChange={el => {
                if (el["customerId"]) {
                    onCustomerChange(el).then(_ => _)
                }
            }}
        >
            <Form.Item name="purchaseCode" label="采购单号">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item
                name="customerId"
                label="客户名称"
                rules={[{required: true, message: '必输字字段',}]}
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择客户"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={customerDict}
                    dropdownClassName="dark-select"
                />
            </Form.Item>
            <Form.Item
                name="customerType"
                label="客户类型"
                rules={[{required: true, message: '必输字字段',}]}
            >
                <TreeSelect
                    showSearch
                    allowClear
                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                    placeholder="客户类型"
                    treeDefaultExpandAll
                    onChange={() => {
                    }}
                    treeData={customerTypeDict}
                />
            </Form.Item>
            <Form.Item
                name="customerPerson"
                label="联系人"
                rules={[{required: true, message: '必输字字段',}]}
            >
                <Input placeholder="联系人"/>
            </Form.Item>
            <Form.Item
                name="customerPhone"
                label="手机号"
                rules={[{required: true, message: '必输字字段',}]}
            >
                <Input placeholder="手机号"/>
            </Form.Item>

            <Form.Item
                name="detailedAddress"
                label="收货地址"
                rules={[{required: true, message: '必输字字段',}]}
            >
                <Input placeholder="收货地址"/>
            </Form.Item>
            <Form.Item
                name="priceType"
                label="售价选择"
                rules={[{required: true, message: '必输字字段',}]}
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="售价选择"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={salePriceTypeDict}
                />
            </Form.Item>
            <Form.Item
                name="orderType"
                label="订单类型"
                rules={[{required: true, message: '必输字字段',}]}
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="订单类型"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={saleOrderTypeDict}
                />
            </Form.Item>
            <Form.Item
                name="invoiceType"
                label="发票类型"
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="发票类型"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={invoiceTypeDict}
                />
            </Form.Item>
            <Form.Item name="saleDesc" label="备注" rules={[{required: false}]}>
                <Input.TextArea/>
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    确定
                </Button>
                <Button htmlType="button" onClick={onClose} className="margin-left-8">
                    取消
                </Button>
            </Form.Item>
        </Form>
    );
}
export default function () {
    const [{transferDrawerVisible}, {setTransferDrawerVisible}] = useModel("purchasePo");
    return (
        <Drawer
            title="转销售单"
            placement="right"
            width={500}
            closable={true}
            onClose={() => {
                setTransferDrawerVisible(false)
            }}
            visible={transferDrawerVisible}
        >
            <TransferForm/>
        </Drawer>
    )
}